import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@store/types';
import { AirflowDashboardHandler } from '@api/airflow-dashboard-handler';
import { AirflowTaskInstanceLinks } from '../../types';

/*
 * Fetches operator-provided extra links for the Details tab's Extra Links card
 */
export function useDetailsTab(dagId: string, runId: string, taskId: string, mapIndex: number, refreshKey: number) {
    const { envVariables: Env } = useSelector((store: RootState) => store.AccountReducer);
    const [links, setLinks] = useState<AirflowTaskInstanceLinks>({});
    const [isLoadingLinks, setIsLoadingLinks] = useState(true);

    useEffect(() => {
        let cancelled = false;
        setIsLoadingLinks(true);
        AirflowDashboardHandler.getTaskInstanceLinks(Env, dagId, runId, taskId, mapIndex)
            .then((response) => {
                if (!cancelled) setLinks(response ?? {});
            })
            .catch(() => {
                if (!cancelled) setLinks({});
            })
            .finally(() => {
                if (!cancelled) setIsLoadingLinks(false);
            });
        return () => {
            cancelled = true;
        };
    }, [Env, dagId, runId, taskId, mapIndex, refreshKey]);

    const availableLinks = Object.entries(links).filter(([, url]) => url) as [string, string][];

    return { availableLinks, isLoadingLinks };
}
